import React, { useRef } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import {
    Box,
    Link,
    Flex,
    Text
} from '@chakra-ui/react';
import FooterMenu from './FooterMenu';
import FooterSecondary from './FooterSecondary';
import lottie from 'lottie-web';
import calderaAnimation from './caldera-lottie.json';
import { useEffect } from 'react';

export default function Footer() {

const lottieRef = useRef(null);

useEffect(() => {
    lottie.loadAnimation({
        container: lottieRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        animationData: calderaAnimation,
    });
    return () => {
        lottie.destroy();
    }
}, []);

    return (
        <Box as="footer">
            <Box h={{base: 2, lg: 4}} bg="sage.500" />
                <FooterMenu />
                <FooterSecondary />
        <Box bg="sage.500" py="2" px="12">
            <Flex w="100%" flexWrap="wrap" justifyContent="center"  overflow="hidden">
                <Box mr="4">
                    <Link as={GatsbyLink} to="/" variant="footer-link">
                        Homepage
                    </Link>
                </Box>
                {/* <Box mr="4">
                    <Link as={GatsbyLink} to="/" variant="footer-link">
                        Sitemap
                    </Link>
                </Box> */}
                <Box mr="4">
                    <Link as={GatsbyLink} to="/" variant="footer-link">
                        Privacy Policy
                    </Link>
                </Box>
                <Box marginLeft={{base: 'none', md: 'auto'}} overflow="hidden">
                    
                        <Text mb="0" color="white" position="relative" zIndex="100">Website by{' '}
                            <Link href="https://caldera-creative.com" color='blue.700' _hover={{ color: 'blue.500', textDecoration: 'none'}}  onTouchStart={() => lottie.play()} onMouseEnter={() => lottie.play()} onMouseLeave={() => lottie.stop()}>
                                Caldera Creative
                            </Link>
                        </Text>
                    
                    <Box h="8rem" w="8rem" position="absolute" right="60px" bottom="0" overflow="hidden">
                        <Box ref={lottieRef} h="8rem" w="8rem" mt="30px" />
                    </Box>                    
                </Box>
            </Flex>
        </Box>
        </Box>
    )
}